var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "0px", overflow: "hidden" } }, [
    _c(
      "div",
      {
        staticClass: "print-content",
        staticStyle: { width: "284px", height: "189px", overflow: "hidden" },
        attrs: { id: "lodopPrintForNoDataPackage" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "font-size": "18px",
              width: "268px",
              "text-align": "center",
              "word-break": "break-all",
              "font-weight": "bold",
              display: "-webkit-box",
              "-webkit-box-orient": "vertical",
              "-webkit-line-clamp": "2",
              overflow: "hidden"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.contents.supply_name) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "el-row",
          {
            staticStyle: { display: "flex", "align-items": "center" },
            attrs: { gutter: 8 }
          },
          [
            _c(
              "el-col",
              { staticStyle: { "text-align": "center" }, attrs: { span: 8 } },
              [
                _c(
                  "div",
                  { staticStyle: { padding: "4px 0" } },
                  [
                    _c("qrcode-vue", {
                      attrs: {
                        value: _vm.contents.no_data_package_no,
                        size: 80,
                        level: "H",
                        "render-as": "svg"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticStyle: { "text-align": "center", "margin-bottom": "2px" },
                attrs: { span: 16 }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "5px",
                      "line-height": "1",
                      "font-size": "16px",
                      "font-weight": "bold",
                      "word-break": "break-all",
                      "-webkit-box-orient": "vertical",
                      "-webkit-line-clamp": "2",
                      overflow: "hidden"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.contents.no_data_package_no) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "5px",
                      "line-height": "1",
                      "font-size": "16px",
                      "font-weight": "bold",
                      "word-break": "break-all",
                      "-webkit-box-orient": "vertical",
                      "-webkit-line-clamp": "2",
                      overflow: "hidden"
                    }
                  },
                  [
                    _vm._v(
                      "\n          件数：" + _vm._s(_vm.contents.tool_num)
                    ),
                    _c("span", { staticStyle: { "margin-left": "12px" } }, [
                      _vm._v(_vm._s(_vm.contents.pgname))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "2px",
                      "font-size": "16px",
                      "line-height": "1.1",
                      "font-weight": "bold",
                      "word-break": "break-all",
                      "-webkit-box-orient": "vertical",
                      "-webkit-line-clamp": "2",
                      overflow: "hidden"
                    }
                  },
                  [
                    _vm._v(
                      "\n          退还方式：" +
                        _vm._s(_vm.contents.return_packet_return_mode_type) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "font-size": "14px",
              width: "268px",
              "text-align": "center",
              "word-break": "break-all",
              "font-weight": "bold",
              "-webkit-box-orient": "vertical",
              "-webkit-line-clamp": "2",
              overflow: "hidden"
            }
          },
          [
            _vm._v(
              "\n      地址：" +
                _vm._s(_vm.contents.return_exchange_receive_address) +
                "\n    "
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d916504", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d916504","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/nodatagoods/components/lodopPrintForNoDataPackage.vue
// module id = null
// module chunks = 